// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"MassMailingEmptyView_ProseMirror__3urO5","emptyView":"MassMailingEmptyView_emptyView__3S8tx","emptyView__text":"MassMailingEmptyView_emptyView__text__3gAfP"};